import React, { useEffect, useState } from 'react'
import { ImagesProvider } from 'app/react/components/images/ImagesContext'
import { useFirstRender } from 'app/react/hooks/useFirstRender'
import useScroll from 'app/react/hooks/useScroll'

export default function ImagesContainer ({
  children,
  restUrl = '',
  headerTitle = '',
  headerText = '',
  categories = [],
  initialCategories = [],
  errorMessage = 'Vi fandt ingen billeder der matchede din søgning. Prøv venligst igen'
}) {

  const [images, setImages] = useState([])
  const [activeCategories, setActiveCategories] = useState([])
  const [activeSearch, setActiveSearch] = useState('')
  const [activePage, setActivePage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [containerRef, setContainerRef] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isSearchLoading, setIsSearchLoading] = useState(false)

  const firstRender = useFirstRender()
  const { scrollTo } = useScroll()

  const fetchImages = () => {
    setIsLoading(true)
    fetch(restUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        's': activeSearch,
        'categories': activeCategories,
        'paged': activePage
      })
    })
      .then(response => response.json())
      .then(response => {
        setImages(response.posts)
        setTotalPages(response.totalPages)
        setIsLoading(false)
        setIsSearchLoading(false)
      })
  }

  useEffect(() => {
    fetchImages()
  }, [activeCategories, activeSearch])

  useEffect(() => {
    if (firstRender) {
      return
    }

    fetchImages()

    if (containerRef?.current) {
      scrollTo(containerRef.current.getBoundingClientRect().top)
    }
  }, [activePage])

  return (
    <ImagesProvider value={{
      restUrl,
      headerTitle,
      headerText,
      categories,
      initialCategories,
      errorMessage,
      activeCategories,
      setActiveCategories,
      activeSearch,
      setActiveSearch,
      images,
      setImages,
      totalPages,
      setTotalPages,
      activePage,
      setActivePage,
      setContainerRef,
      isLoading,
      isSearchLoading,
      setIsSearchLoading
    }}>
      {children}
    </ImagesProvider>
  )
}